// import React, { useState, useEffect, useRef } from 'react';
// import axios from 'axios';
// import { FaEdit, FaTrash } from 'react-icons/fa';
// import * as XLSX from 'xlsx';

// const ItemDiscounts = () => {
//     const [data, setData] = useState([]);
//     const [loading, setLoading] = useState(true);
//     const [error, setError] = useState(null);
//     const [filteredData, setFilteredData] = useState([]);
//     const [editItem, setEditItem] = useState(null);
//     const [showEditModal, setShowEditModal] = useState(false);
//     const [showBulkEditModal, setShowBulkEditModal] = useState(false); // New state for bulk edit
//     const [bulkDiscountValue, setBulkDiscountValue] = useState(""); // New state for bulk discount
//     const [selectedItems, setSelectedItems] = useState({}); // Track selected items
//     const fileInputRef = useRef(null);
//     const tableContainerRef = useRef(null);
//     const [bulkOfferType, setBulkOfferType] = useState("FESTIAVAL_OFFER"); // Add this line

//     // Custom loader functions
//     const showLoader = () => {
//         //console.log("Loading...");
//     };

//     const hideLoader = () => {
//         //console.log("Loading complete");
//     };
//     // Handle individual checkbox change
//     // Handle individual checkbox change
//     const handleCheckboxChange = (dishId, isSubcategory = false, parentIndex = null) => {
//         setSelectedItems(prev => {
//             const newSelected = { ...prev };
//             const key = isSubcategory ? `${parentIndex}-${dishId}` : dishId;

//             if (newSelected[key]) {
//                 // Uncheck
//                 delete newSelected[key];

//                 // If unchecking a child, uncheck parent if it was checked
//                 if (isSubcategory && parentIndex !== null) {
//                     const parentId = data[parentIndex]?.dishId;
//                     if (parentId && newSelected[parentId]) {
//                         // Check if any children of this parent are still selected
//                         const anyChildSelected = data[parentIndex]?.subcategories?.some(sub => {
//                             const childKey = `${parentIndex}-${sub.dishId}`;
//                             return newSelected[childKey];
//                         });

//                         // If no children are selected, uncheck the parent
//                         if (!anyChildSelected) {
//                             delete newSelected[parentId];
//                         }
//                     }
//                 }

//                 // If unchecking parent, uncheck all its children
//                 if (!isSubcategory) {
//                     const category = data.find(item => item.dishId === dishId);
//                     if (category && category.subcategories) {
//                         category.subcategories.forEach(sub => {
//                             const subKey = `${data.findIndex(item => item.dishId === dishId)}-${sub.dishId}`;
//                             delete newSelected[subKey];
//                         });
//                     }
//                 }
//             } else {
//                 // Check
//                 newSelected[key] = { dishId, isSubcategory, parentIndex };

//                 // If checking a child, check parent if all children are now selected
//                 if (isSubcategory && parentIndex !== null) {
//                     const parentId = data[parentIndex]?.dishId;
//                     const parent = data[parentIndex];

//                     if (parent && parent.subcategories) {
//                         // Check if all children are now selected
//                         const allChildrenSelected = parent.subcategories.every(sub => {
//                             const childKey = `${parentIndex}-${sub.dishId}`;
//                             return newSelected[childKey];
//                         });

//                         // If all children are selected, check the parent too
//                         if (allChildrenSelected) {
//                             newSelected[parentId] = {
//                                 dishId: parentId,
//                                 isSubcategory: false,
//                                 parentIndex: null
//                             };
//                         }
//                     }
//                 }
//             }

//             return newSelected;
//         });
//     };

//     const handleParentCheckboxChange = (index, dishId) => {
//         setSelectedItems(prev => {
//             const newSelected = { ...prev };
//             const category = data[index];
//             const parentKey = dishId;

//             // Check if parent is currently selected
//             const isParentSelected = newSelected[parentKey];

//             if (isParentSelected) {
//                 // If parent is selected, unselect parent and all children
//                 delete newSelected[parentKey];

//                 if (category.subcategories) {
//                     category.subcategories.forEach(sub => {
//                         const subKey = `${index}-${sub.dishId}`;
//                         delete newSelected[subKey];
//                     });
//                 }
//             } else {
//                 // If parent is not selected, select parent and all children
//                 newSelected[parentKey] = { dishId, isSubcategory: false, parentIndex: null };

//                 if (category.subcategories) {
//                     category.subcategories.forEach((sub, subIndex) => {
//                         const subKey = `${index}-${sub.dishId}`;
//                         newSelected[subKey] = {
//                             dishId: sub.dishId,
//                             isSubcategory: true,
//                             parentIndex: index
//                         };
//                     });
//                 }
//             }

//             return newSelected;
//         });
//     };
//     // Check if parent should be in indeterminate state (some children selected)
//     const isParentIndeterminate = (parentIndex) => {
//         const parent = data[parentIndex];
//         if (!parent || !parent.subcategories) return false;

//         const parentId = parent.dishId;
//         const childKeys = parent.subcategories.map(sub => `${parentIndex}-${sub.dishId}`);

//         const isParentSelected = !!selectedItems[parentId];
//         const selectedChildrenCount = childKeys.filter(key => selectedItems[key]).length;
//         const totalChildrenCount = parent.subcategories.length;

//         // Parent is indeterminate if some but not all children are selected
//         return !isParentSelected && selectedChildrenCount > 0 && selectedChildrenCount < totalChildrenCount;
//     };

//     // Select/Deselect All
//     // Select/Deselect All
//     const handleSelectAll = () => {
//         const allSelectedCount = Object.keys(selectedItems).length;
//         const totalItemsCount = data.reduce((total, category) =>
//             total + 1 + (category.subcategories?.length || 0), 0);

//         if (allSelectedCount === totalItemsCount) {
//             // Deselect all
//             setSelectedItems({});
//         } else {
//             // Select all
//             const newSelected = {};

//             data.forEach((category, index) => {
//                 // Select parent
//                 newSelected[category.dishId] = {
//                     dishId: category.dishId,
//                     isSubcategory: false,
//                     parentIndex: null
//                 };

//                 // Select all children
//                 if (category.subcategories) {
//                     category.subcategories.forEach(sub => {
//                         const key = `${index}-${sub.dishId}`;
//                         newSelected[key] = {
//                             dishId: sub.dishId,
//                             isSubcategory: true,
//                             parentIndex: index
//                         };
//                     });
//                 }
//             });

//             setSelectedItems(newSelected);
//         }
//     };

//     // Get checked items count
//     const getSelectedCount = () => {
//         return Object.keys(selectedItems).length;
//     };

//     // Get selected items for bulk update
//     const getSelectedItems = () => {
//         return Object.values(selectedItems);
//     };
//     // Open bulk edit modal
//     const handleBulkEdit = () => {
//         const selectedCount = getSelectedCount();
//         if (selectedCount === 0) {
//             alert("Please select at least one item to update.");
//             return;
//         }
//         setBulkDiscountValue("");
//         setBulkOfferType("FESTIAVAL_OFFER"); // Reset to default
//         setShowBulkEditModal(true);
//     };

//     // Apply bulk discount
//     const applyBulkDiscount = async () => {
//         const selectedItemsList = getSelectedItems();
//         if (selectedItemsList.length === 0) {
//             alert("No items selected.");
//             return;
//         }

//         if (!bulkDiscountValue || isNaN(bulkDiscountValue) || parseFloat(bulkDiscountValue) < 0) {
//             alert("Please enter a valid discount percentage.");
//             return;
//         }

//         const discountValue = parseFloat(bulkDiscountValue);
//         const token = localStorage.getItem("authToken");

//         if (!token) {
//             alert("Authentication token missing.");
//             return;
//         }

//         try {
//             showLoader();

//             // Update each selected item
//             const updatePromises = selectedItemsList.map(async (item) => {
//                 // Fetch current dish data to preserve other fields
//                 const response = await axios.get(
//                     `https://backend.maamaas.com/food/api/dish/get/${item.dishId}`,
//                     {
//                         headers: { Authorization: `Bearer ${token}` },
//                     }
//                 );

//                 const dishData = response.data;

//                 // Create update object with current fields + new discount + offerType
//                 const updateData = {
//                     dishId: dishData.dishId,
//                     dishName: dishData.dishName || "",
//                     price: dishData.price || 0,
//                     discount: discountValue,
//                     offerType: bulkOfferType, // Use the bulk offer type
//                     tag: dishData.tag || "Veg",
//                     stockQuantity: dishData.stockQuantity || 0,
//                     gst: dishData.gst || 0,
//                     packingCharges: dishData.packingCharges || 0,
//                     description: dishData.description || "",
//                     title: dishData.title || dishData.dishName || "",
//                     priceAfterDiscount: 0
//                 };

//                 const formData = new FormData();
//                 formData.append("dishData", new Blob([JSON.stringify(updateData)], {
//                     type: "application/json"
//                 }));

//                 return axios.put(
//                     `https://backend.maamaas.com/food/api/dish/edit/${item.dishId}`,
//                     formData,
//                     {
//                         headers: {
//                             "Authorization": `Bearer ${token}`,
//                             "Content-Type": "multipart/form-data",
//                         },
//                     }
//                 );
//             });

//             await Promise.all(updatePromises);

//             // Update local state
//             const updatedData = [...data];
//             const displayText = discountValue > 0 ? `${discountValue}` : "-";

//             selectedItemsList.forEach(item => {
//                 const updateObj = {
//                     discount: displayText,
//                     discountValue: discountValue,
//                     offerType: bulkOfferType
//                 };

//                 if (item.isSubcategory && item.parentIndex !== null) {
//                     // Update subcategory
//                     const subIndex = updatedData[item.parentIndex].subcategories?.findIndex(
//                         sub => sub.dishId === item.dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[item.parentIndex].subcategories[subIndex] = {
//                             ...updatedData[item.parentIndex].subcategories[subIndex],
//                             ...updateObj
//                         };
//                     }
//                 } else {
//                     // Update parent category
//                     const parentIndex = updatedData.findIndex(cat => cat.dishId === item.dishId);
//                     if (parentIndex !== -1) {
//                         updatedData[parentIndex] = {
//                             ...updatedData[parentIndex],
//                             ...updateObj
//                         };

//                         // Also update all children if parent is selected
//                         if (updatedData[parentIndex].subcategories) {
//                             updatedData[parentIndex].subcategories.forEach(sub => {
//                                 Object.assign(sub, updateObj);
//                             });
//                         }
//                     }
//                 }
//             });

//             setData(updatedData);
//             setFilteredData(updatedData);
//             setSelectedItems({}); // Clear selection after update
//             setShowBulkEditModal(false);
//             setBulkDiscountValue("");
//             setBulkOfferType("FESTIAVAL_OFFER"); // Reset to default

//             alert(`Discount updated for ${selectedItemsList.length} item(s) successfully!`);

//         } catch (error) {
//             console.error("Error in bulk update:", error);
//             alert("Failed to update some items. Please try again.");
//         } finally {
//             hideLoader();
//         }
//     };
//     // Fetch categories with discount data
//     const fetchData = async () => {
//         const vendorId = localStorage.getItem("vendorId");
//         const token = localStorage.getItem("authToken");

//         if (!vendorId || !token) {
//             setError(new Error("Authentication required. Please log in again."));
//             setLoading(false);
//             return;
//         }

//         try {
//             showLoader();
//             const response = await fetch(
//                 `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
//                 {
//                     headers: {
//                         "Content-Type": "application/json",
//                         "Authorization": `Bearer ${token}`
//                     }
//                 }
//             );

//             if (!response.ok) {
//                 throw new Error(`HTTP error! status: ${response.status}`);
//             }

//             const dishData = await response.json();

//             // Get parent categories (categories)
//             const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

//             // Format the data with categories and discount information
//             const formattedData = parentCategories.map((category, index) => ({
//                 dishId: category.dishId,
//                 SNo: index + 1,
//                 category: category.dishName,
//                 discount: category.discount || "-", // Default discount
//                 discountType: category.discountType || "percentage", // percentage or fixed
//                 discountValue: category.discountValue || 0,
//                 itemStatus: category.menuStatus || "Enable",
//                 subcategories: dishData
//                     .filter(sub => sub.parentId === category.dishId)
//                     .map(sub => ({
//                         dishId: sub.dishId,
//                         subName: sub.subName || sub.dishName,
//                         discount: sub.discount || "0",
//                         discountType: sub.discountType || "percentage",
//                         discountValue: sub.discountValue || 0,
//                         itemStatus: sub.menuStatus || "Enable",
//                         isSubcategory: true
//                     }))
//             }));

//             //console.log("Discount Data:", formattedData);
//             setData(formattedData);
//             setFilteredData(formattedData);

//         } catch (error) {
//             console.error("Error fetching discount data:", error);
//             setError(error);
//         } finally {
//             setLoading(false);
//             hideLoader();
//         }
//     };

//     useEffect(() => {
//         fetchData();
//     }, []);

//     // Handle file import
//     const handleFileImport = async (e) => {
//         const file = e.target.files[0];
//         if (!file) return alert("Please choose a file.");

//         const vendorId = localStorage.getItem("vendorId");
//         const authToken = localStorage.getItem("authToken");

//         if (!vendorId || !authToken) {
//             alert("Authentication required. Please log in first.");
//             return;
//         }

//         const formData = new FormData();
//         formData.append("file", file);

//         try {
//             showLoader();
//             const response = await axios.post(
//                 `https://backend.maamaas.com/food/api/dish/import-discounts/${vendorId}`,
//                 formData,
//                 {
//                     headers: {
//                         "Content-Type": "multipart/form-data",
//                         Authorization: `Bearer ${authToken}`,
//                     },
//                 }
//             );

//             //console.log("✅ Discounts import successful:", response.data);
//             alert("✅ Discounts imported successfully!");
//             fetchData(); // Refresh data

//         } catch (error) {
//             console.error("❌ Import failed:", error);
//             if (error.response) {
//                 alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
//             } else {
//                 alert("❌ Import failed: Network or unknown error.");
//             }
//         } finally {
//             hideLoader();
//         }
//     };

//     // Handle export to Excel
//     const handleExport = () => {
//         if (!filteredData || filteredData.length === 0) {
//             alert("No data available to export.");
//             return;
//         }

//         const exportData = [];

//         filteredData.forEach((category, index) => {
//             exportData.push({
//                 "S.No": index + 1,
//                 "Category": category.category || "",
//                 "Discount": category.discount || "-",
//                 "Discount Type": category.discountType || "percentage",
//                 "Discount Value": category.discountValue || 0,
//             });

//             if (category.subcategories && category.subcategories.length > 0) {
//                 category.subcategories.forEach((sub) => {
//                     exportData.push({
//                         "S.No": "",
//                         "Category": category.category || "",
//                         "Subcategory": sub.subName || "",
//                         "Discount": sub.discount || "-",
//                         "Discount Type": sub.discountType || "percentage",
//                         "Discount Value": sub.discountValue || 0,
//                     });
//                 });
//             }
//         });

//         const worksheet = XLSX.utils.json_to_sheet(exportData);
//         const workbook = XLSX.utils.book_new();
//         XLSX.utils.book_append_sheet(workbook, worksheet, "Discount Data");

//         const colWidths = Object.keys(exportData[0]).map((key) => ({
//             wch: Math.max(
//                 key.length,
//                 ...exportData.map((row) => String(row[key] || "").length)
//             ),
//         }));
//         worksheet["!cols"] = colWidths;

//         XLSX.writeFile(workbook, "discount_data_export.xlsx");
//     };

//     // Handle edit discount
//     // Handle edit discount
//     // Handle edit discount
//     const handleEditDiscount = async (item, isSubcategory = false, parentIndex = null) => {
//         try {
//             const token = localStorage.getItem("authToken");
//             if (!token) {
//                 alert("Authentication token missing. Please log in again.");
//                 return;
//             }

//             // Fetch current dish data to get all fields
//             const response = await axios.get(
//                 `https://backend.maamaas.com/food/api/dish/get/${item.dishId}`,
//                 {
//                     headers: {
//                         Authorization: `Bearer ${token}`,
//                     },
//                 }
//             );

//             const dishData = response.data;

//             // Parse current discount value
//             let currentValue = 0;
//             if (dishData.discount !== null && dishData.discount !== undefined) {
//                 if (typeof dishData.discount === 'string') {
//                     // Extract number from string (e.g., "10%" -> 10)
//                     const match = dishData.discount.match(/(\d+(\.\d+)?)/);
//                     currentValue = match ? parseFloat(match[0]) : 0;
//                 } else if (typeof dishData.discount === 'number') {
//                     currentValue = dishData.discount;
//                 }
//             }

//             setEditItem({
//                 ...dishData, // Include all current dish data
//                 newDiscountValue: currentValue,
//                 newDiscountType: "percentage", // Always use percentage since API expects number
//                 isSubcategory,
//                 parentIndex
//             });
//             setShowEditModal(true);

//         } catch (error) {
//             console.error("Error fetching dish details:", error);
//             alert("Error fetching dish details. Please try again.");
//         }
//     };


//     // Submit edited discount
//     const submitEditDiscount = async () => {
//         if (!editItem || !editItem.dishId) {
//             alert("Dish ID is missing!");
//             return;
//         }

//         const token = localStorage.getItem("authToken");
//         if (!token) {
//             alert("Authentication token missing. Please log in again.");
//             return;
//         }

//         try {
//             showLoader();
//             const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

//             // Parse discount value - ALWAYS percentage
//             const discountValue = parseFloat(editItem.newDiscountValue) || 0;

//             // Get offerType
//             const offerType = editItem.newOfferType || "FESTIAVAL_OFFER"; // Default to FESTIAVAL_OFFER

//             // Create update object
//             const updateData = {
//                 dishId: editItem.dishId,
//                 dishName: editItem.dishName || "",
//                 price: editItem.price || 0,
//                 discount: discountValue, // Always percentage number
//                 offerType: offerType, // Add offerType for categorization
//                 tag: editItem.tag || "Veg",
//                 stockQuantity: editItem.stockQuantity || 0,
//                 gst: editItem.gst || 0,
//                 packingCharges: editItem.packingCharges || 0,
//                 description: editItem.description || "",
//                 title: editItem.title || editItem.dishName || "",
//                 priceAfterDiscount: 0
//             };

//             const formData = new FormData();
//             formData.append("dishData", new Blob([JSON.stringify(updateData)], { type: "application/json" }));

//             const response = await axios.put(url, formData, {
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "multipart/form-data",
//                 },
//             });

//             //console.log('Discount update successful:', response.data);
//             alert('Discount updated successfully!');

//             // Update local state
//             const displayText = discountValue > 0 ? `${discountValue}` : "-";

//             const updateObj = {
//                 discount: displayText,
//                 discountValue: discountValue,
//                 offerType: offerType
//             };

//             // ... rest of your update logic remains the same
//             if (editItem.isSubcategory && editItem.parentIndex !== null) {
//                 setData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === editItem.dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[editItem.parentIndex].subcategories[subIndex] = {
//                             ...updatedData[editItem.parentIndex].subcategories[subIndex],
//                             ...updateObj
//                         };
//                     }
//                     return updatedData;
//                 });
//                 setFilteredData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === editItem.dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[editItem.parentIndex].subcategories[subIndex] = {
//                             ...updatedData[editItem.parentIndex].subcategories[subIndex],
//                             ...updateObj
//                         };
//                     }
//                     return updatedData;
//                 });
//             } else {
//                 setData(prevData =>
//                     prevData.map(item =>
//                         item.dishId === editItem.dishId
//                             ? { ...item, ...updateObj }
//                             : item
//                     )
//                 );
//                 setFilteredData(prevData =>
//                     prevData.map(item =>
//                         item.dishId === editItem.dishId
//                             ? { ...item, ...updateObj }
//                             : item
//                     )
//                 );
//             }

//             setShowEditModal(false);
//             setEditItem(null);

//         } catch (error) {
//             console.error("Error updating discount:", error);
//             if (error.response) {
//                 alert(`Failed to update discount: ${error.response.data.message || error.response.data}`);
//             } else {
//                 alert(`Failed to update discount: ${error.message}`);
//             }
//         } finally {
//             hideLoader();
//         }
//     };

//     // Handle delete discount (set to 0%)
//     // Handle delete discount (set to 0%)
//     const handleDeleteDiscount = async (dishId, isSubcategory = false, parentIndex = null) => {
//         if (!window.confirm("Are you sure you want to remove discount for this item?")) return;

//         try {
//             showLoader();
//             // Call API to remove discount
//             const token = localStorage.getItem("authToken");
//             const url = `https://backend.maamaas.com/food/api/dish/edit/${dishId}`;

//             const formData = new FormData();
//             const dishData = {
//                 discount: "-",
//                 discountType: "percentage",
//                 discountValue: 0
//             };

//             formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

//             await axios.put(url, formData, {
//                 headers: {
//                     "Authorization": `Bearer ${token}`,
//                     "Content-Type": "multipart/form-data",
//                 },
//             });

//             alert("Discount removed successfully!");

//             // Update local state
//             const updateDiscount = "-"; // Use dash for removed discount

//             if (isSubcategory && parentIndex !== null) {
//                 setData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[parentIndex].subcategories[subIndex] = {
//                             ...updatedData[parentIndex].subcategories[subIndex],
//                             discount: updateDiscount,
//                             discountType: "percentage",
//                             discountValue: 0
//                         };
//                     }
//                     return updatedData;
//                 });
//                 setFilteredData(prevData => {
//                     const updatedData = [...prevData];
//                     const subIndex = updatedData[parentIndex].subcategories.findIndex(
//                         sub => sub.dishId === dishId
//                     );
//                     if (subIndex !== -1) {
//                         updatedData[parentIndex].subcategories[subIndex] = {
//                             ...updatedData[parentIndex].subcategories[subIndex],
//                             discount: updateDiscount,
//                             discountType: "percentage",
//                             discountValue: 0
//                         };
//                     }
//                     return updatedData;
//                 });
//             } else {
//                 setData(prevData =>
//                     prevData.map(item =>
//                         item.dishId === dishId
//                             ? {
//                                 ...item,
//                                 discount: updateDiscount,
//                                 discountType: "percentage",
//                                 discountValue: 0
//                             }
//                             : item
//                     )
//                 );
//                 setFilteredData(prevData =>
//                     prevData.map(item =>
//                         item.dishId === dishId
//                             ? {
//                                 ...item,
//                                 discount: updateDiscount,
//                                 discountType: "percentage",
//                                 discountValue: 0
//                             }
//                             : item
//                     )
//                 );
//             }

//         } catch (error) {
//             console.error("Error removing discount:", error);
//             alert("Failed to remove discount.");
//         } finally {
//             hideLoader();
//         }
//     };

//     // Responsive styles
//     const getResponsiveValue = (mobile, tablet, desktop) => {
//         const width = window.innerWidth;
//         if (width < 768) return mobile;
//         if (width < 1024) return tablet;
//         return desktop;
//     };

//     const containerHeight = getResponsiveValue('60vh', '65vh', '70vh');

//     // Table header style with sticky positioning
//     const tableHeaderStyle = {
//         border: '1px solid #ddd',
//         textAlign: 'center',
//         fontWeight: 'bold',
//         backgroundColor: '#b15cd6',
//         color: 'white',
//         padding: getResponsiveValue('0.5rem', '0.75rem', '0.875rem'),
//         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
//         whiteSpace: 'nowrap',
//         position: 'sticky',
//         top: 0,
//         zIndex: 10,
//     };

//     const tableCellStyle = {
//         border: '1px solid #ddd',
//         textAlign: 'center',
//         padding: getResponsiveValue('0.4rem', '0.6rem', '0.75rem'),
//         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
//         wordBreak: 'break-word',
//     };

//     const categoryRowStyle = {
//         backgroundColor: '#f0f0f0',
//         fontWeight: 'bold'
//     };

//     const subcategoryRowStyle = {
//         backgroundColor: '#f9f9f9'
//     };

//     const editButtonStyle = {
//         backgroundColor: '#fff',
//         color: 'green',
//         border: 'none',
//         cursor: 'pointer',
//         borderRadius: '0.25rem',
//         marginRight: getResponsiveValue('0.25rem', '0.5rem', '0.625rem'),
//         fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
//         padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
//         display: 'inline-flex',
//         alignItems: 'center',
//         justifyContent: 'center'
//     };

//     const deleteButtonStyle = {
//         backgroundColor: '#fff',
//         color: 'red',
//         border: 'none',
//         cursor: 'pointer',
//         borderRadius: '0.25rem',
//         fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
//         padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
//         display: 'inline-flex',
//         alignItems: 'center',
//         justifyContent: 'center'
//     };

//     const importExportButton = {
//         height: '35px',
//         marginTop: "20px",
//         borderRadius: "4px",
//         border: "none",
//         backgroundColor: "#b15cd6",
//         color: "white",
//         fontWeight: 'bold',
//         padding: '0 8px',
//         cursor: 'pointer',
//         fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
//     };

//     return (
//         <div style={{
//             marginTop: window.innerWidth < 768 ? "0rem" : "2rem",
//             padding: getResponsiveValue('0rem 0.5rem 0.5rem 0rem', '0rem 1rem 1rem 0rem', '0rem 1.25rem 1.25rem 0rem'),
//             width: '100%',
//             boxSizing: 'border-box',
//         }}>
//             <div className='importexportaddbutton' style={{
//                 display: "flex",
//                 gap: "10px",
//                 marginBottom: "0rem",
//                 marginTop: "-70px",
//                 padding: window.innerWidth < 768 ? "10px 20px 5px 0px " : "10px 20px 10px 0px",
//                 justifyContent: "start",
//                 flexWrap: 'wrap'
//             }}>
//                 <input
//                     type="file"
//                     accept=".xlsx, .xls"
//                     ref={fileInputRef}
//                     onChange={handleFileImport}
//                     style={{ display: 'none' }}
//                 />

//                 <button
//                     style={importExportButton}
//                     onClick={() => fileInputRef.current.click()}
//                 >
//                     Import
//                 </button>

//                 <button style={importExportButton} onClick={handleExport}>
//                     Export
//                 </button>
//             </div>

//             {/* Single Table Container with Fixed Header */}
//             <div
//                 ref={tableContainerRef}
//                 style={{
//                     height: window.innerHeight <= 500 ? "45vh" : window.innerHeight <= 600 ? "50vh" : "55vh",
//                     border: '0px solid #ddd',
//                     borderRadius: '0.375rem',
//                     backgroundColor: '#fff',
//                     width: '100%',
//                     maxWidth: '100%',
//                     boxSizing: 'border-box',
//                     overflow: 'hidden',
//                     display: 'flex',
//                     flexDirection: 'column'
//                 }}
//             >
//                 {loading ? (
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '1.25rem',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '100%'
//                     }}>
//                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                             Loading discount data...
//                         </p>
//                     </div>
//                 ) : error ? (
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '1.25rem',
//                         color: 'red',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '100%'
//                     }}>
//                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                             Error: {error.message}
//                         </p>
//                     </div>
//                 ) : filteredData.length === 0 ? (
//                     <div style={{
//                         textAlign: 'center',
//                         padding: '1.25rem',
//                         display: 'flex',
//                         alignItems: 'center',
//                         justifyContent: 'center',
//                         height: '100%'
//                     }}>
//                         <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                             No items with discounts found
//                         </p>
//                     </div>
//                 ) : (
//                     <div style={{
//                         overflow: 'auto',
//                         height: '100%',
//                         scrollbarWidth: "thin",

//                     }}>
//                         <table style={{
//                             width: '100%',
//                             borderCollapse: 'collapse',
//                             tableLayout: 'fixed',
//                             // minWidth: getResponsiveValue('600px', '800px', '1000px'),
//                             marginTop: "0px",
//                         }}>
//                             <thead>
//                                 <tr>
//                                     <th style={{ ...tableHeaderStyle, width: '7%' }}>
//                                         <input
//                                             type="checkbox"
//                                             checked={Object.keys(selectedItems).length > 0 &&
//                                                 Object.keys(selectedItems).length ===
//                                                 data.reduce((total, category) =>
//                                                     total + 1 + (category.subcategories?.length || 0), 0)}
//                                             onChange={handleSelectAll}
//                                             style={{ cursor: 'pointer' }}
//                                         />
//                                     </th>
//                                     <th style={{ ...tableHeaderStyle, width: '8%' }}>SNo</th>
//                                     <th style={{ ...tableHeaderStyle, width: '30%' }}>Category</th>
//                                     <th style={{ ...tableHeaderStyle, width: '30%' }}>Discount(%)</th>
//                                     <th style={{ ...tableHeaderStyle, width: '25%' }}>Actions</th>
//                                 </tr>
//                             </thead>
//                             <tbody>
//                                 {filteredData.map((item, index) => (
//                                     <React.Fragment key={item.dishId}>
//                                         {/* Parent Category Row */}
//                                         {/* Parent Category Row */}
//                                         <tr style={categoryRowStyle}>
//                                             <td style={{ ...tableCellStyle, width: '5%' }}>
//                                                 <input
//                                                     type="checkbox"
//                                                     ref={(el) => {
//                                                         if (el) {
//                                                             el.indeterminate = isParentIndeterminate(index);
//                                                         }
//                                                     }}
//                                                     checked={!!selectedItems[item.dishId]}
//                                                     onChange={() => handleParentCheckboxChange(index, item.dishId)}
//                                                     style={{ cursor: 'pointer' }}
//                                                 />
//                                             </td>
//                                             <td style={{ ...tableCellStyle, width: '8%' }}>{index + 1}</td>
//                                             <td style={{ ...tableCellStyle, width: '35%' }}>
//                                                 <strong style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
//                                                     {item.category}
//                                                 </strong>
//                                             </td>
//                                             <td style={{ ...tableCellStyle, width: '30%' }}>
//                                                 <span style={{
//                                                     color: item.discount !== "-" ? '#e74c3c' : '#666',
//                                                     fontWeight: item.discount !== "-" ? 'bold' : 'normal',
//                                                     fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem')
//                                                 }}>
//                                                     -
//                                                 </span>
//                                             </td>
//                                             <td style={{ ...tableCellStyle, width: '22%' }}>
//                                                 <div style={{
//                                                     display: 'flex',
//                                                     justifyContent: 'center',
//                                                     alignItems: 'center',
//                                                     gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
//                                                 }}>
//                                                     {/* <button
//                                                         style={editButtonStyle}
//                                                         onClick={() => handleEditDiscount(item, false)}
//                                                         title="Edit Discount"
//                                                         aria-label="Edit Discount"
//                                                     >
//                                                         <FaEdit />
//                                                     </button> */}
//                                                     <button
//                                                         style={{
//                                                             ...importExportButton,
//                                                             padding: '5px 10px',
//                                                             fontSize: '12px',
//                                                             height: 'auto',
//                                                             marginTop: "0px",
//                                                         }}
//                                                         onClick={handleBulkEdit}
//                                                         disabled={getSelectedCount() === 0}
//                                                     >
//                                                         Bulk Edit
//                                                     </button>
//                                                 </div>
//                                             </td>
//                                         </tr>

//                                         {/* Subcategories */}
//                                         {/* Subcategories */}
//                                         {/* Subcategories */}
//                                         {item.subcategories && item.subcategories.map((sub, subIndex) => {
//                                             const subKey = `${index}-${sub.dishId}`;
//                                             return (
//                                                 <tr key={`sub-${sub.dishId}`} style={subcategoryRowStyle}>
//                                                     <td style={{ ...tableCellStyle, width: '5%' }}>
//                                                         <input
//                                                             type="checkbox"
//                                                             checked={!!selectedItems[subKey]}
//                                                             onChange={() => handleCheckboxChange(sub.dishId, true, index)}
//                                                             style={{ cursor: 'pointer' }}
//                                                         />
//                                                     </td>
//                                                     <td style={{ ...tableCellStyle, width: '8%' }}>
//                                                         {index + 1}.{subIndex + 1}
//                                                     </td>
//                                                     <td style={{ ...tableCellStyle, width: '35%' }}>
//                                                         <span style={{
//                                                             marginLeft: getResponsiveValue('1rem', '1.5rem', '2rem'),
//                                                             display: 'block',
//                                                             textAlign: 'left',
//                                                             fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem')
//                                                         }}>
//                                                             ↳ {sub.subName}
//                                                         </span>
//                                                     </td>
//                                                     <td style={{ ...tableCellStyle, width: '30%' }}>
//                                                         <span style={{
//                                                             color: sub.discount !== "-" ? '#292828ff' : '#666',
//                                                             fontWeight: sub.discount !== "-" ? 'normal' : 'normal',
//                                                             fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem')
//                                                         }}>
//                                                             {sub.discount}
//                                                         </span>
//                                                     </td>
//                                                     <td style={{ ...tableCellStyle, width: '22%' }}>
//                                                         <div style={{
//                                                             display: 'flex',
//                                                             justifyContent: 'center',
//                                                             alignItems: 'center',
//                                                             gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
//                                                         }}>
//                                                             <button
//                                                                 style={editButtonStyle}
//                                                                 onClick={() => handleEditDiscount(sub, true, index)}
//                                                                 title="Edit Discount"
//                                                                 aria-label="Edit Discount"
//                                                             >
//                                                                 <FaEdit />
//                                                             </button>
//                                                         </div>
//                                                     </td>
//                                                 </tr>
//                                             );
//                                         })}
//                                     </React.Fragment>
//                                 ))}
//                             </tbody>
//                         </table>
//                     </div>
//                 )}
//             </div>

//             {/* Edit Discount Modal */}
//             {showEditModal && editItem && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0,0,0,0.5)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 1000,
//                 }}>
//                     <div style={{
//                         backgroundColor: 'white',
//                         padding: '1.5rem',
//                         borderRadius: '8px',
//                         width: '280px',
//                         maxWidth: '90%',
//                         boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                         position: 'relative',
//                     }}>
//                         <button
//                             onClick={() => setShowEditModal(false)}
//                             style={{
//                                 position: 'absolute',
//                                 top: '10px',
//                                 right: '10px',
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: '1.5rem',
//                                 cursor: 'pointer',
//                                 color: '#999',
//                             }}
//                         >
//                             ×
//                         </button>

//                         <h3 style={{ marginBottom: '1rem', color: '#333', textAlign: 'center' }}>
//                             Edit Discount
//                         </h3>

//                         {/* Offer Type Selection - Just for categorization */}
//                         <div style={{ marginBottom: '1rem' }}>
//                             <label style={{
//                                 display: 'block',
//                                 marginBottom: '0.5rem',
//                                 fontWeight: '500',
//                                 color: '#333',
//                                 fontSize: '14px'
//                             }}>
//                                 Offer Type:
//                             </label>
//                             <div style={{
//                                 display: 'flex',
//                                 gap: '10px',
//                                 marginBottom: '10px'
//                             }}>
//                                 <button
//                                     type="button"
//                                     onClick={() => setEditItem({ ...editItem, newOfferType: "FESTIAVAL_OFFER" })}
//                                     style={{
//                                         flex: 1,
//                                         padding: '0.5rem',
//                                         border: `2px solid ${editItem.newOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#ddd'}`,
//                                         borderRadius: '6px',
//                                         backgroundColor: editItem.newOfferType === "FESTIAVAL_OFFER" ? '#f0e6f5' : 'white',
//                                         cursor: 'pointer',
//                                         fontWeight: editItem.newOfferType === "FESTIAVAL_OFFER" ? 'bold' : 'normal',
//                                         color: editItem.newOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#333',
//                                     }}
//                                 >
//                                     Festival Offer
//                                 </button>
//                                 <button
//                                     type="button"
//                                     onClick={() => setEditItem({ ...editItem, newOfferType: "FLAT_OFFER" })}
//                                     style={{
//                                         flex: 1,
//                                         padding: '0.5rem',
//                                         border: `2px solid ${editItem.newOfferType === "FLAT_OFFER" ? '#b15cd6' : '#ddd'}`,
//                                         borderRadius: '6px',
//                                         backgroundColor: editItem.newOfferType === "FLAT_OFFER" ? '#f0e6f5' : 'white',
//                                         cursor: 'pointer',
//                                         fontWeight: editItem.newOfferType === "FLAT_OFFER" ? 'bold' : 'normal',
//                                         color: editItem.newOfferType === "FLAT_OFFER" ? '#b15cd6' : '#333',
//                                     }}
//                                 >
//                                     Flat Offer
//                                 </button>
//                             </div>
//                         </div>

//                         {/* Discount Value Input - Always Percentage */}
//                         <div style={{ marginBottom: '1.5rem' }}>
//                             <label style={{
//                                 display: 'block',
//                                 marginBottom: '0.5rem',
//                                 fontWeight: '500',
//                                 color: '#333',
//                                 fontSize: '14px'
//                             }}>
//                                 Discount Percentage:
//                             </label>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                 <input
//                                     type="number"
//                                     value={editItem.newDiscountValue}
//                                     onChange={(e) => setEditItem({ ...editItem, newDiscountValue: e.target.value })}
//                                     style={{
//                                         flex: 1,
//                                         padding: '0.65rem',
//                                         border: '1px solid #ddd',
//                                         borderRadius: '6px',
//                                         fontSize: '0.9rem',
//                                     }}
//                                     min="0"
//                                     max="100"
//                                     step="0.1"
//                                     placeholder="e.g. 10"
//                                     autoFocus
//                                 />
//                                 <span style={{
//                                     color: '#666',
//                                     fontSize: '14px',
//                                     fontWeight: 'bold',
//                                     minWidth: '30px'
//                                 }}>
//                                     %
//                                 </span>
//                             </div>
//                             <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
//                                 Enter 0 to remove discount
//                             </small>
//                         </div>

//                         {/* Save Button */}
//                         <button
//                             onClick={submitEditDiscount}
//                             style={{
//                                 width: '100%',
//                                 padding: '0.75rem',
//                                 backgroundColor: '#b15cd6',
//                                 color: 'white',
//                                 border: 'none',
//                                 borderRadius: '6px',
//                                 fontSize: '1rem',
//                                 cursor: 'pointer',
//                                 fontWeight: 'bold',
//                                 marginTop: '5px'
//                             }}
//                         >
//                             Save Discount
//                         </button>

//                     </div>
//                 </div>
//             )}
//             {/* Bulk Edit Modal */}
//             {showBulkEditModal && (
//                 <div style={{
//                     position: 'fixed',
//                     top: 0,
//                     left: 0,
//                     right: 0,
//                     bottom: 0,
//                     backgroundColor: 'rgba(0,0,0,0.5)',
//                     display: 'flex',
//                     justifyContent: 'center',
//                     alignItems: 'center',
//                     zIndex: 1001,
//                 }}>
//                     <div style={{
//                         backgroundColor: 'white',
//                         padding: '1.5rem',
//                         borderRadius: '8px',
//                         width: '350px',
//                         maxWidth: '90%',
//                         boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
//                         position: 'relative',
//                     }}>
//                         <button
//                             onClick={() => setShowBulkEditModal(false)}
//                             style={{
//                                 position: 'absolute',
//                                 top: '10px',
//                                 right: '10px',
//                                 background: 'none',
//                                 border: 'none',
//                                 fontSize: '1.5rem',
//                                 cursor: 'pointer',
//                                 color: '#999',
//                             }}
//                         >
//                             ×
//                         </button>

//                         <h3 style={{ marginBottom: '1rem', color: '#333', textAlign: 'center' }}>
//                             Bulk Discount Update
//                         </h3>

//                         <p style={{
//                             marginBottom: '1rem',
//                             textAlign: 'center',
//                             color: '#666',
//                             fontSize: '14px'
//                         }}>
//                             Updating {getSelectedCount()} selected item(s)
//                         </p>

//                         {/* Offer Type Selection for Bulk Edit */}
//                         <div style={{ marginBottom: '1rem' }}>
//                             <label style={{
//                                 display: 'block',
//                                 marginBottom: '0.5rem',
//                                 fontWeight: '500',
//                                 color: '#333',
//                                 fontSize: '14px'
//                             }}>
//                                 Offer Type:
//                             </label>
//                             <div style={{
//                                 display: 'flex',
//                                 gap: '10px',
//                                 marginBottom: '15px'
//                             }}>
//                                 <button
//                                     type="button"
//                                     onClick={() => setBulkOfferType("FESTIAVAL_OFFER")}
//                                     style={{
//                                         flex: 1,
//                                         padding: '0.6rem',
//                                         border: `2px solid ${bulkOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#ddd'}`,
//                                         borderRadius: '6px',
//                                         backgroundColor: bulkOfferType === "FESTIAVAL_OFFER" ? '#f0e6f5' : 'white',
//                                         cursor: 'pointer',
//                                         fontWeight: bulkOfferType === "FESTIAVAL_OFFER" ? 'bold' : 'normal',
//                                         color: bulkOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#333',
//                                         fontSize: '14px'
//                                     }}
//                                 >
//                                     Festival Offer
//                                 </button>
//                                 <button
//                                     type="button"
//                                     onClick={() => setBulkOfferType("FLAT_OFFER")}
//                                     style={{
//                                         flex: 1,
//                                         padding: '0.6rem',
//                                         border: `2px solid ${bulkOfferType === "FLAT_OFFER" ? '#b15cd6' : '#ddd'}`,
//                                         borderRadius: '6px',
//                                         backgroundColor: bulkOfferType === "FLAT_OFFER" ? '#f0e6f5' : 'white',
//                                         cursor: 'pointer',
//                                         fontWeight: bulkOfferType === "FLAT_OFFER" ? 'bold' : 'normal',
//                                         color: bulkOfferType === "FLAT_OFFER" ? '#b15cd6' : '#333',
//                                         fontSize: '14px'
//                                     }}
//                                 >
//                                     Flat Offer
//                                 </button>
//                             </div>
//                         </div>

//                         {/* Discount Percentage Input */}
//                         <div style={{ marginBottom: '1.5rem' }}>
//                             <label style={{
//                                 display: 'block',
//                                 marginBottom: '0.5rem',
//                                 fontWeight: '500',
//                                 color: '#333',
//                                 fontSize: '14px'
//                             }}>
//                                 Discount Percentage:
//                             </label>
//                             <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
//                                 <input
//                                     type="number"
//                                     value={bulkDiscountValue}
//                                     onChange={(e) => setBulkDiscountValue(e.target.value)}
//                                     style={{
//                                         flex: 1,
//                                         padding: '0.75rem',
//                                         border: '1px solid #ddd',
//                                         borderRadius: '6px',
//                                         fontSize: '1rem',
//                                     }}
//                                     min="0"
//                                     max="100"
//                                     step="0.1"
//                                     placeholder="Enter discount %"
//                                     autoFocus
//                                 />
//                                 <span style={{
//                                     color: '#666',
//                                     fontSize: '16px',
//                                     fontWeight: 'bold',
//                                     minWidth: '30px'
//                                 }}>
//                                     %
//                                 </span>
//                             </div>
//                             <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
//                                 Enter 0 to remove discount from all selected items
//                             </small>
//                         </div>

//                         {/* Apply Button */}
//                         <button
//                             onClick={applyBulkDiscount}
//                             style={{
//                                 width: '100%',
//                                 padding: '0.75rem',
//                                 backgroundColor: '#b15cd6',
//                                 color: 'white',
//                                 border: 'none',
//                                 borderRadius: '6px',
//                                 fontSize: '1rem',
//                                 cursor: 'pointer',
//                                 fontWeight: 'bold',
//                                 marginTop: '5px'
//                             }}
//                         >
//                             Apply to All Selected Items
//                         </button>

//                     </div>
//                 </div>
//             )}

//             <style jsx>{`
//                 /* CSS for fixed header */
//                 .table-container {
//                     position: relative;
//                     height: ${containerHeight};
//                     overflow: auto;
//                 }
                
//                 .table-container thead th {
//                     position: sticky;
//                     top: 0;
//                     background-color: #b15cd6;
//                     z-index: 10;
//                 }
                
//                 /* Hide scrollbar for Chrome, Safari and Opera */
//                 .table-container::-webkit-scrollbar {
//                     width: 8px;
//                     height: 8px;
//                 }
                
//                 .table-container::-webkit-scrollbar-track {
//                     background: #f1f1f1;
//                 }
                
//                 .table-container::-webkit-scrollbar-thumb {
//                     background: #888;
//                     border-radius: 4px;
//                 }
                
//                 .table-container::-webkit-scrollbar-thumb:hover {
//                     background: #555;
//                 }
//             `}</style>
//         </div>
//     );
// };

// export default ItemDiscounts;


import React, { useState, useEffect, useRef } from 'react';
import axios from 'axios';
import { FaEdit, FaTrash } from 'react-icons/fa';
import * as XLSX from 'xlsx';

const ItemDiscounts = () => {
    const [data, setData] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [filteredData, setFilteredData] = useState([]);
    const [editItem, setEditItem] = useState(null);
    const [showEditModal, setShowEditModal] = useState(false);
    const [showBulkEditModal, setShowBulkEditModal] = useState(false); // New state for bulk edit
    const [bulkDiscountValue, setBulkDiscountValue] = useState(""); // New state for bulk discount
    const [selectedItems, setSelectedItems] = useState({}); // Track selected items
    const fileInputRef = useRef(null);
    const tableContainerRef = useRef(null);
    const [searchQuery, setSearchQuery] = useState("");
    const [searchActive, setSearchActive] = useState(false);
    const [isVegSelected, setIsVegSelected] = useState(null);


    const [bulkOfferType, setBulkOfferType] = useState("FESTIAVAL_OFFER"); // Add this line

    const normalizeForSearch = (text) => {
        if (!text) return '';

        // Convert to lowercase and replace multiple separators with space
        return text
            .toLowerCase()
            .replace(/[-\s_]+/g, ' ')  // Replace hyphens, underscores, multiple spaces with single space
            .trim();
    };

    const handleSearch = (query) => {
        const searchTerm = normalizeForSearch(query);
        setSearchQuery(query);

        if (!searchTerm) {
            setSearchActive(false);
            applyFilter(data, isVegSelected);
            return;
        }

        setSearchActive(true);

        // Create search patterns:
        // 1. Exact match (with spaces normalized)
        // 2. Without spaces (for "vegmeals")
        // 3. Individual words
        const searchWithoutSpaces = searchTerm.replace(/\s+/g, '');
        const searchWords = searchTerm.split(/\s+/).filter(w => w.length > 0);

        const searchResults = data.map(category => {
            // Normalize category
            const normalizedCategory = normalizeForSearch(category.category);
            const categoryWithoutSpaces = normalizedCategory.replace(/\s+/g, '');

            // Check category matches
            const categoryMatches =
                normalizedCategory.includes(searchTerm) ||
                categoryWithoutSpaces.includes(searchWithoutSpaces) ||
                searchWords.every(word => normalizedCategory.includes(word));

            // Filter subcategories
            const filteredSubcategories = category.subcategories?.filter(sub => {
                // Normalize subcategory fields
                const normalizedSubName = normalizeForSearch(sub.subName);
                const normalizedDescription = normalizeForSearch(sub.description);
                const normalizedTag = normalizeForSearch(sub.tag);

                const subNameWithoutSpaces = normalizedSubName.replace(/\s+/g, '');
                const descWithoutSpaces = normalizedDescription.replace(/\s+/g, '');

                // Multiple matching strategies
                const nameMatches =
                    normalizedSubName.includes(searchTerm) ||
                    subNameWithoutSpaces.includes(searchWithoutSpaces) ||
                    searchWords.every(word => normalizedSubName.includes(word));

                const descMatches =
                    normalizedDescription.includes(searchTerm) ||
                    descWithoutSpaces.includes(searchWithoutSpaces) ||
                    searchWords.every(word => normalizedDescription.includes(word));

                const tagMatches =
                    normalizedTag.includes(searchTerm) ||
                    normalizedTag.replace(/\s+/g, '').includes(searchWithoutSpaces);

                return nameMatches || descMatches || tagMatches;
            });

            // Include category if it matches or has matching subcategories
            if (categoryMatches || (filteredSubcategories && filteredSubcategories.length > 0)) {
                return {
                    ...category,
                    subcategories: categoryMatches ? category.subcategories : filteredSubcategories
                };
            }

            return null;
        }).filter(category => category !== null);

        setFilteredData(searchResults);
    };
    const applyFilter = (allData, vegOnly) => {
        let filtered = allData;

        // Apply veg filter if selected
        if (vegOnly !== null) {
            filtered = allData.map(category => {
                const filteredSubcategories = category.subcategories.filter(
                    sub => vegOnly ? sub.tag === "Veg" : sub.tag === "Non_Veg"
                );

                return {
                    ...category,
                    subcategories: filteredSubcategories
                };
            }).filter(cat => cat.subcategories.length > 0);
        }

        // Apply search if active
        if (searchActive && searchQuery) {
            filtered = filtered.map(category => {
                const categoryMatches = category.category?.toLowerCase().includes(searchQuery);

                const filteredSubcategories = category.subcategories.filter(sub =>
                    sub.subName?.toLowerCase().includes(searchQuery) ||
                    sub.description?.toLowerCase().includes(searchQuery)
                );

                if (categoryMatches || filteredSubcategories.length > 0) {
                    return {
                        ...category,
                        subcategories: categoryMatches ? category.subcategories : filteredSubcategories
                    };
                }
                return null;
            }).filter(category => category !== null);
        }

        setFilteredData(filtered);
    };
    // Custom loader functions
    const showLoader = () => {
        //console.log("Loading...");
    };

    const hideLoader = () => {
        //console.log("Loading complete");
    };
    // Handle individual checkbox change
    // Handle individual checkbox change
    const handleCheckboxChange = (dishId, isSubcategory = false, parentIndex = null) => {
        setSelectedItems(prev => {
            const newSelected = { ...prev };
            const key = isSubcategory ? `${parentIndex}-${dishId}` : dishId;

            if (newSelected[key]) {
                // Uncheck
                delete newSelected[key];

                // If unchecking a child, uncheck parent if it was checked
                if (isSubcategory && parentIndex !== null) {
                    const parentId = data[parentIndex]?.dishId;
                    if (parentId && newSelected[parentId]) {
                        // Check if any children of this parent are still selected
                        const anyChildSelected = data[parentIndex]?.subcategories?.some(sub => {
                            const childKey = `${parentIndex}-${sub.dishId}`;
                            return newSelected[childKey];
                        });

                        // If no children are selected, uncheck the parent
                        if (!anyChildSelected) {
                            delete newSelected[parentId];
                        }
                    }
                }

                // If unchecking parent, uncheck all its children
                if (!isSubcategory) {
                    const category = data.find(item => item.dishId === dishId);
                    if (category && category.subcategories) {
                        category.subcategories.forEach(sub => {
                            const subKey = `${data.findIndex(item => item.dishId === dishId)}-${sub.dishId}`;
                            delete newSelected[subKey];
                        });
                    }
                }
            } else {
                // Check
                newSelected[key] = { dishId, isSubcategory, parentIndex };

                // If checking a child, check parent if all children are now selected
                if (isSubcategory && parentIndex !== null) {
                    const parentId = data[parentIndex]?.dishId;
                    const parent = data[parentIndex];

                    if (parent && parent.subcategories) {
                        // Check if all children are now selected
                        const allChildrenSelected = parent.subcategories.every(sub => {
                            const childKey = `${parentIndex}-${sub.dishId}`;
                            return newSelected[childKey];
                        });

                        // If all children are selected, check the parent too
                        if (allChildrenSelected) {
                            newSelected[parentId] = {
                                dishId: parentId,
                                isSubcategory: false,
                                parentIndex: null
                            };
                        }
                    }
                }
            }

            return newSelected;
        });
    };

    const handleParentCheckboxChange = (index, dishId) => {
        setSelectedItems(prev => {
            const newSelected = { ...prev };
            const category = data[index];
            const parentKey = dishId;

            // Check if parent is currently selected
            const isParentSelected = newSelected[parentKey];

            if (isParentSelected) {
                // If parent is selected, unselect parent and all children
                delete newSelected[parentKey];

                if (category.subcategories) {
                    category.subcategories.forEach(sub => {
                        const subKey = `${index}-${sub.dishId}`;
                        delete newSelected[subKey];
                    });
                }
            } else {
                // If parent is not selected, select parent and all children
                newSelected[parentKey] = { dishId, isSubcategory: false, parentIndex: null };

                if (category.subcategories) {
                    category.subcategories.forEach((sub, subIndex) => {
                        const subKey = `${index}-${sub.dishId}`;
                        newSelected[subKey] = {
                            dishId: sub.dishId,
                            isSubcategory: true,
                            parentIndex: index
                        };
                    });
                }
            }

            return newSelected;
        });
    };
    // Check if parent should be in indeterminate state (some children selected)
    const isParentIndeterminate = (parentIndex) => {
        const parent = data[parentIndex];
        if (!parent || !parent.subcategories) return false;

        const parentId = parent.dishId;
        const childKeys = parent.subcategories.map(sub => `${parentIndex}-${sub.dishId}`);

        const isParentSelected = !!selectedItems[parentId];
        const selectedChildrenCount = childKeys.filter(key => selectedItems[key]).length;
        const totalChildrenCount = parent.subcategories.length;

        // Parent is indeterminate if some but not all children are selected
        return !isParentSelected && selectedChildrenCount > 0 && selectedChildrenCount < totalChildrenCount;
    };

    // Select/Deselect All
    // Select/Deselect All
    const handleSelectAll = () => {
        const allSelectedCount = Object.keys(selectedItems).length;
        const totalItemsCount = data.reduce((total, category) =>
            total + 1 + (category.subcategories?.length || 0), 0);

        if (allSelectedCount === totalItemsCount) {
            // Deselect all
            setSelectedItems({});
        } else {
            // Select all
            const newSelected = {};

            data.forEach((category, index) => {
                // Select parent
                newSelected[category.dishId] = {
                    dishId: category.dishId,
                    isSubcategory: false,
                    parentIndex: null
                };

                // Select all children
                if (category.subcategories) {
                    category.subcategories.forEach(sub => {
                        const key = `${index}-${sub.dishId}`;
                        newSelected[key] = {
                            dishId: sub.dishId,
                            isSubcategory: true,
                            parentIndex: index
                        };
                    });
                }
            });

            setSelectedItems(newSelected);
        }
    };

    // Get checked items count
    const getSelectedCount = () => {
        return Object.keys(selectedItems).length;
    };

    // Get selected items for bulk update
    const getSelectedItems = () => {
        return Object.values(selectedItems);
    };
    // Open bulk edit modal
    const handleBulkEdit = () => {
        const selectedCount = getSelectedCount();
        if (selectedCount === 0) {
            alert("Please select at least one item to update.");
            return;
        }
        setBulkDiscountValue("");
        setBulkOfferType("FESTIAVAL_OFFER"); // Reset to default
        setShowBulkEditModal(true);
    };

    // Apply bulk discount
    const applyBulkDiscount = async () => {
        const selectedItemsList = getSelectedItems();
        if (selectedItemsList.length === 0) {
            alert("No items selected.");
            return;
        }

        if (!bulkDiscountValue || isNaN(bulkDiscountValue) || parseFloat(bulkDiscountValue) < 0) {
            alert("Please enter a valid discount percentage.");
            return;
        }

        const discountValue = parseFloat(bulkDiscountValue);
        const token = localStorage.getItem("authToken");

        if (!token) {
            alert("Authentication token missing.");
            return;
        }

        try {
            showLoader();

            // Update each selected item
            const updatePromises = selectedItemsList.map(async (item) => {
                // Fetch current dish data to preserve other fields
                const response = await axios.get(
                    `https://backend.maamaas.com/food/api/dish/get/${item.dishId}`,
                    {
                        headers: { Authorization: `Bearer ${token}` },
                    }
                );

                const dishData = response.data;

                // Create update object with current fields + new discount + offerType
                const updateData = {
                    dishId: dishData.dishId,
                    dishName: dishData.dishName || "",
                    price: dishData.price || 0,
                    discount: discountValue,
                    offerType: bulkOfferType, // Use the bulk offer type
                    tag: dishData.tag || "Veg",
                    stockQuantity: dishData.stockQuantity || 0,
                    gst: dishData.gst || 0,
                    packingCharges: dishData.packingCharges || 0,
                    description: dishData.description || "",
                    title: dishData.title || dishData.dishName || "",
                    priceAfterDiscount: 0
                };

                const formData = new FormData();
                formData.append("dishData", new Blob([JSON.stringify(updateData)], {
                    type: "application/json"
                }));

                return axios.put(
                    `https://backend.maamaas.com/food/api/dish/edit/${item.dishId}`,
                    formData,
                    {
                        headers: {
                            "Authorization": `Bearer ${token}`,
                            "Content-Type": "multipart/form-data",
                        },
                    }
                );
            });

            await Promise.all(updatePromises);

            // Update local state
            const updatedData = [...data];
            const displayText = discountValue > 0 ? `${discountValue}` : "-";

            selectedItemsList.forEach(item => {
                const updateObj = {
                    discount: displayText,
                    discountValue: discountValue,
                    offerType: bulkOfferType
                };

                if (item.isSubcategory && item.parentIndex !== null) {
                    // Update subcategory
                    const subIndex = updatedData[item.parentIndex].subcategories?.findIndex(
                        sub => sub.dishId === item.dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[item.parentIndex].subcategories[subIndex] = {
                            ...updatedData[item.parentIndex].subcategories[subIndex],
                            ...updateObj
                        };
                    }
                } else {
                    // Update parent category
                    const parentIndex = updatedData.findIndex(cat => cat.dishId === item.dishId);
                    if (parentIndex !== -1) {
                        updatedData[parentIndex] = {
                            ...updatedData[parentIndex],
                            ...updateObj
                        };

                        // Also update all children if parent is selected
                        if (updatedData[parentIndex].subcategories) {
                            updatedData[parentIndex].subcategories.forEach(sub => {
                                Object.assign(sub, updateObj);
                            });
                        }
                    }
                }
            });

            setData(updatedData);
            setFilteredData(updatedData);
            setSelectedItems({}); // Clear selection after update
            setShowBulkEditModal(false);
            setBulkDiscountValue("");
            setBulkOfferType("FESTIAVAL_OFFER"); // Reset to default

            alert(`Discount updated for ${selectedItemsList.length} item(s) successfully!`);

        } catch (error) {
            console.error("Error in bulk update:", error);
            alert("Failed to update some items. Please try again.");
        } finally {
            hideLoader();
        }
    };
    // Fetch categories with discount data
    const fetchData = async () => {
        const vendorId = localStorage.getItem("vendorId");
        const token = localStorage.getItem("authToken");

        if (!vendorId || !token) {
            setError(new Error("Authentication required. Please log in again."));
            setLoading(false);
            return;
        }

        try {
            showLoader();
            const response = await fetch(
                `https://backend.maamaas.com/food/api/dish/getbyvendor/${vendorId}`,
                {
                    headers: {
                        "Content-Type": "application/json",
                        "Authorization": `Bearer ${token}`
                    }
                }
            );

            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }

            const dishData = await response.json();

            // Get parent categories (categories)
            const parentCategories = dishData.filter(item => item.parentId === 0 || item.parentId === null);

            // Format the data with categories and discount information
            const formattedData = parentCategories.map((category, index) => ({
                dishId: category.dishId,
                SNo: index + 1,
                category: category.dishName,
                discount: category.discount || "-", // Default discount
                discountType: category.discountType || "percentage", // percentage or fixed
                discountValue: category.discountValue || 0,
                itemStatus: category.menuStatus || "Enable",
                subcategories: dishData
                    .filter(sub => sub.parentId === category.dishId)
                    .map(sub => ({
                        dishId: sub.dishId,
                        subName: sub.subName || sub.dishName,
                        discount: sub.discount || "0",
                        discountType: sub.discountType || "percentage",
                        discountValue: sub.discountValue || 0,
                        itemStatus: sub.menuStatus || "Enable",
                        isSubcategory: true
                    }))
            }));

            //console.log("Discount Data:", formattedData);
            setData(formattedData);
            setFilteredData(formattedData);

        } catch (error) {
            console.error("Error fetching discount data:", error);
            setError(error);
        } finally {
            setLoading(false);
            hideLoader();
        }
    };

    useEffect(() => {
        fetchData();
    }, []);

    // Handle file import
    const handleFileImport = async (e) => {
        const file = e.target.files[0];
        if (!file) return alert("Please choose a file.");

        const vendorId = localStorage.getItem("vendorId");
        const authToken = localStorage.getItem("authToken");

        if (!vendorId || !authToken) {
            alert("Authentication required. Please log in first.");
            return;
        }

        const formData = new FormData();
        formData.append("file", file);

        try {
            showLoader();
            const response = await axios.post(
                `https://backend.maamaas.com/food/api/dish/import-discounts/${vendorId}`,
                formData,
                {
                    headers: {
                        "Content-Type": "multipart/form-data",
                        Authorization: `Bearer ${authToken}`,
                    },
                }
            );

            //console.log("✅ Discounts import successful:", response.data);
            alert("✅ Discounts imported successfully!");
            fetchData(); // Refresh data

        } catch (error) {
            console.error("❌ Import failed:", error);
            if (error.response) {
                alert(`❌ Import failed: ${error.response.status} - ${error.response.data?.message || "Server error"}`);
            } else {
                alert("❌ Import failed: Network or unknown error.");
            }
        } finally {
            hideLoader();
        }
    };

    // Handle export to Excel
    const handleExport = () => {
        if (!filteredData || filteredData.length === 0) {
            alert("No data available to export.");
            return;
        }

        const exportData = [];

        filteredData.forEach((category, index) => {
            exportData.push({
                "S.No": index + 1,
                "Category": category.category || "",
                "Discount": category.discount || "-",
                "Discount Type": category.discountType || "percentage",
                "Discount Value": category.discountValue || 0,
            });

            if (category.subcategories && category.subcategories.length > 0) {
                category.subcategories.forEach((sub) => {
                    exportData.push({
                        "S.No": "",
                        "Category": category.category || "",
                        "Subcategory": sub.subName || "",
                        "Discount": sub.discount || "-",
                        "Discount Type": sub.discountType || "percentage",
                        "Discount Value": sub.discountValue || 0,
                    });
                });
            }
        });

        const worksheet = XLSX.utils.json_to_sheet(exportData);
        const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(workbook, worksheet, "Discount Data");

        const colWidths = Object.keys(exportData[0]).map((key) => ({
            wch: Math.max(
                key.length,
                ...exportData.map((row) => String(row[key] || "").length)
            ),
        }));
        worksheet["!cols"] = colWidths;

        XLSX.writeFile(workbook, "discount_data_export.xlsx");
    };

    // Handle edit discount
    // Handle edit discount
    // Handle edit discount
    const handleEditDiscount = async (item, isSubcategory = false, parentIndex = null) => {
        try {
            const token = localStorage.getItem("authToken");
            if (!token) {
                alert("Authentication token missing. Please log in again.");
                return;
            }

            // Fetch current dish data to get all fields
            const response = await axios.get(
                `https://backend.maamaas.com/food/api/dish/get/${item.dishId}`,
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                    },
                }
            );

            const dishData = response.data;

            // Parse current discount value
            let currentValue = 0;
            if (dishData.discount !== null && dishData.discount !== undefined) {
                if (typeof dishData.discount === 'string') {
                    // Extract number from string (e.g., "10%" -> 10)
                    const match = dishData.discount.match(/(\d+(\.\d+)?)/);
                    currentValue = match ? parseFloat(match[0]) : 0;
                } else if (typeof dishData.discount === 'number') {
                    currentValue = dishData.discount;
                }
            }

            setEditItem({
                ...dishData, // Include all current dish data
                newDiscountValue: currentValue,
                newDiscountType: "percentage", // Always use percentage since API expects number
                isSubcategory,
                parentIndex
            });
            setShowEditModal(true);

        } catch (error) {
            console.error("Error fetching dish details:", error);
            alert("Error fetching dish details. Please try again.");
        }
    };


    // Submit edited discount
    const submitEditDiscount = async () => {
        if (!editItem || !editItem.dishId) {
            alert("Dish ID is missing!");
            return;
        }

        const token = localStorage.getItem("authToken");
        if (!token) {
            alert("Authentication token missing. Please log in again.");
            return;
        }

        try {
            showLoader();
            const url = `https://backend.maamaas.com/food/api/dish/edit/${editItem.dishId}`;

            // Parse discount value - ALWAYS percentage
            const discountValue = parseFloat(editItem.newDiscountValue) || 0;

            // Get offerType
            const offerType = editItem.newOfferType || "FESTIAVAL_OFFER"; // Default to FESTIAVAL_OFFER

            // Create update object
            const updateData = {
                dishId: editItem.dishId,
                dishName: editItem.dishName || "",
                price: editItem.price || 0,
                discount: discountValue, // Always percentage number
                offerType: offerType, // Add offerType for categorization
                tag: editItem.tag || "Veg",
                stockQuantity: editItem.stockQuantity || 0,
                gst: editItem.gst || 0,
                packingCharges: editItem.packingCharges || 0,
                description: editItem.description || "",
                title: editItem.title || editItem.dishName || "",
                priceAfterDiscount: 0
            };

            const formData = new FormData();
            formData.append("dishData", new Blob([JSON.stringify(updateData)], { type: "application/json" }));

            const response = await axios.put(url, formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            //console.log('Discount update successful:', response.data);
            alert('Discount updated successfully!');

            // Update local state
            const displayText = discountValue > 0 ? `${discountValue}` : "-";

            const updateObj = {
                discount: displayText,
                discountValue: discountValue,
                offerType: offerType
            };

            // ... rest of your update logic remains the same
            if (editItem.isSubcategory && editItem.parentIndex !== null) {
                setData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
                        sub => sub.dishId === editItem.dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[editItem.parentIndex].subcategories[subIndex] = {
                            ...updatedData[editItem.parentIndex].subcategories[subIndex],
                            ...updateObj
                        };
                    }
                    return updatedData;
                });
                setFilteredData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[editItem.parentIndex].subcategories.findIndex(
                        sub => sub.dishId === editItem.dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[editItem.parentIndex].subcategories[subIndex] = {
                            ...updatedData[editItem.parentIndex].subcategories[subIndex],
                            ...updateObj
                        };
                    }
                    return updatedData;
                });
            } else {
                setData(prevData =>
                    prevData.map(item =>
                        item.dishId === editItem.dishId
                            ? { ...item, ...updateObj }
                            : item
                    )
                );
                setFilteredData(prevData =>
                    prevData.map(item =>
                        item.dishId === editItem.dishId
                            ? { ...item, ...updateObj }
                            : item
                    )
                );
            }

            setShowEditModal(false);
            setEditItem(null);

        } catch (error) {
            console.error("Error updating discount:", error);
            if (error.response) {
                alert(`Failed to update discount: ${error.response.data.message || error.response.data}`);
            } else {
                alert(`Failed to update discount: ${error.message}`);
            }
        } finally {
            hideLoader();
        }
    };

    // Handle delete discount (set to 0%)
    // Handle delete discount (set to 0%)
    const handleDeleteDiscount = async (dishId, isSubcategory = false, parentIndex = null) => {
        if (!window.confirm("Are you sure you want to remove discount for this item?")) return;

        try {
            showLoader();
            // Call API to remove discount
            const token = localStorage.getItem("authToken");
            const url = `https://backend.maamaas.com/food/api/dish/edit/${dishId}`;

            const formData = new FormData();
            const dishData = {
                discount: "-",
                discountType: "percentage",
                discountValue: 0
            };

            formData.append("dishData", new Blob([JSON.stringify(dishData)], { type: "application/json" }));

            await axios.put(url, formData, {
                headers: {
                    "Authorization": `Bearer ${token}`,
                    "Content-Type": "multipart/form-data",
                },
            });

            alert("Discount removed successfully!");

            // Update local state
            const updateDiscount = "-"; // Use dash for removed discount

            if (isSubcategory && parentIndex !== null) {
                setData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[parentIndex].subcategories.findIndex(
                        sub => sub.dishId === dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[parentIndex].subcategories[subIndex] = {
                            ...updatedData[parentIndex].subcategories[subIndex],
                            discount: updateDiscount,
                            discountType: "percentage",
                            discountValue: 0
                        };
                    }
                    return updatedData;
                });
                setFilteredData(prevData => {
                    const updatedData = [...prevData];
                    const subIndex = updatedData[parentIndex].subcategories.findIndex(
                        sub => sub.dishId === dishId
                    );
                    if (subIndex !== -1) {
                        updatedData[parentIndex].subcategories[subIndex] = {
                            ...updatedData[parentIndex].subcategories[subIndex],
                            discount: updateDiscount,
                            discountType: "percentage",
                            discountValue: 0
                        };
                    }
                    return updatedData;
                });
            } else {
                setData(prevData =>
                    prevData.map(item =>
                        item.dishId === dishId
                            ? {
                                ...item,
                                discount: updateDiscount,
                                discountType: "percentage",
                                discountValue: 0
                            }
                            : item
                    )
                );
                setFilteredData(prevData =>
                    prevData.map(item =>
                        item.dishId === dishId
                            ? {
                                ...item,
                                discount: updateDiscount,
                                discountType: "percentage",
                                discountValue: 0
                            }
                            : item
                    )
                );
            }

        } catch (error) {
            console.error("Error removing discount:", error);
            alert("Failed to remove discount.");
        } finally {
            hideLoader();
        }
    };

    // Responsive styles
    const getResponsiveValue = (mobile, tablet, desktop) => {
        const width = window.innerWidth;
        if (width < 768) return mobile;
        if (width < 1024) return tablet;
        return desktop;
    };

    const containerHeight = getResponsiveValue('60vh', '65vh', '70vh');

    // Table header style with sticky positioning
    const tableHeaderStyle = {
        border: '1px solid #ddd',
        textAlign: 'center',
        fontWeight: 'bold',
        backgroundColor: '#b15cd6',
        color: 'white',
        padding: getResponsiveValue('0.5rem', '0.75rem', '0.875rem'),
        fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
        whiteSpace: 'nowrap',
        position: 'sticky',
        top: 0,
        zIndex: 10,
    };

    const tableCellStyle = {
        border: '1px solid #ddd',
        textAlign: 'center',
        padding: getResponsiveValue('0.4rem', '0.6rem', '0.75rem'),
        fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
        wordBreak: 'break-word',
    };

    const categoryRowStyle = {
        backgroundColor: '#f0f0f0',
        fontWeight: 'bold'
    };

    const subcategoryRowStyle = {
        backgroundColor: '#f9f9f9'
    };

    const editButtonStyle = {
        backgroundColor: '#fff',
        color: 'green',
        border: 'none',
        cursor: 'pointer',
        borderRadius: '0.25rem',
        marginRight: getResponsiveValue('0.25rem', '0.5rem', '0.625rem'),
        fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
        padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    };

    const deleteButtonStyle = {
        backgroundColor: '#fff',
        color: 'red',
        border: 'none',
        cursor: 'pointer',
        borderRadius: '0.25rem',
        fontSize: getResponsiveValue('1rem', '1.125rem', '1.25rem'),
        padding: getResponsiveValue('0.25rem', '0.375rem', '0.5rem'),
        display: 'inline-flex',
        alignItems: 'center',
        justifyContent: 'center'
    };

    const importExportButton = {
        height: '35px',
        marginTop: "20px",
        borderRadius: "4px",
        border: "none",
        backgroundColor: "#b15cd6",
        color: "white",
        fontWeight: 'bold',
        padding: '0 8px',
        cursor: 'pointer',
        fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem'),
    };

    return (
        <>
            <div style={{
                marginTop: window.innerWidth < 768 ? "0rem" : "-2rem",
                padding: getResponsiveValue('0rem 0rem 0.5rem 0rem', '0rem 1rem 1rem 0rem', '0rem 1.25rem 1.25rem 0rem'),
                width: '100%',
                boxSizing: 'border-box',
            }}>
                {/* <div className='importexportaddbutton' style={{
                display: "flex",
                gap: "10px",
                marginBottom: "0rem",
                marginTop: "-70px",
                padding: window.innerWidth < 768 ? "10px 20px 5px 0px " : "10px 20px 10px 0px",
                justifyContent: "start",
                flexWrap: 'wrap'
            }}>
                <input
                    type="file"
                    accept=".xlsx, .xls"
                    ref={fileInputRef}
                    onChange={handleFileImport}
                    style={{ display: 'none' }}
                />

                <button
                    style={importExportButton}
                    onClick={() => fileInputRef.current.click()}
                >
                    Import
                </button>

                <button style={importExportButton} onClick={handleExport}>
                    Export
                </button>

            </div> */}


                {/* Main Controls Container */}
                <div className="controls-container" style={{
                    display: 'flex',
                    flexDirection:window.innerWidth<420 ? "column" : window.innerWidth < 768 ? 'row-reverse' : 'row',
                    justifyContent: window.innerWidth < 768 ? 'flex-start' : 'space-between',
                    alignItems: window.innerWidth < 768 ? 'stretch' : 'center',
                    marginBottom: window.innerWidth < 768 ? '10px' : '10px',
                    gap: window.innerWidth < 768 ? '15px' : '10px',
                    width: '100%',
                    padding: window.innerWidth < 768 ? '0' : '0 0px',
                    marginTop:window.innerHeight<768 ? "1.5rem" : "1rem",
                    boxSizing: 'border-box',
                    
                }}>

                    {/* Buttons Group - Import/Export */}
                    <div style={{
                        display: 'flex',
                        flexDirection: window.innerWidth < 480 ? 'row' : 'row',
                        gap: window.innerWidth < 480 ? '8px' : '10px',
                        justifyContent: window.innerWidth < 768 ? 'start' : 'flex-start',
                        alignItems: 'center',
                        flexWrap: 'wrap',
                        width: window.innerWidth < 768 ? '100%' : 'auto',
                        order: window.innerWidth < 768 ? 2 : 0 // Buttons come after search on mobile
                    }}>
                        <input
                            type="file"
                            accept=".xlsx, .xls"
                            ref={fileInputRef}
                            onChange={handleFileImport}
                            style={{ display: 'none' }}
                        />

                        <button
                            style={{
                                backgroundColor: "#b15cd6",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: 'bold',
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                height: window.innerWidth < 480 ? '32px' :
                                    window.innerWidth < 768 ? '35px' : '38px',
                                padding: window.innerWidth < 480 ? '0 12px' :
                                    window.innerWidth < 768 ? '0 15px' : '0 20px',
                                fontSize: window.innerWidth < 480 ? '0.75rem' :
                                    window.innerWidth < 768 ? '0.85rem' : '0.9rem',
                                minWidth: window.innerWidth < 480 ? '90px' :
                                    window.innerWidth < 768 ? '100px' : '110px',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                margin: 0
                            }}
                            onClick={() => fileInputRef.current.click()}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#9a4bc2'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#b15cd6'}
                        >
                            Import
                        </button>

                        <button
                            style={{
                                backgroundColor: "#b15cd6",
                                color: "white",
                                border: "none",
                                borderRadius: "4px",
                                fontWeight: 'bold',
                                cursor: "pointer",
                                whiteSpace: "nowrap",
                                height: window.innerWidth < 480 ? '32px' :
                                    window.innerWidth < 768 ? '35px' : '38px',
                                padding: window.innerWidth < 480 ? '0 12px' :
                                    window.innerWidth < 768 ? '0 15px' : '0 20px',
                                fontSize: window.innerWidth < 480 ? '0.75rem' :
                                    window.innerWidth < 768 ? '0.85rem' : '0.9rem',
                                minWidth: window.innerWidth < 480 ? '90px' :
                                    window.innerWidth < 768 ? '100px' : '110px',
                                transition: 'all 0.3s ease',
                                boxShadow: '0 2px 4px rgba(0,0,0,0.1)',
                                margin: 0
                            }}
                            onClick={handleExport}
                            onMouseEnter={(e) => e.target.style.backgroundColor = '#9a4bc2'}
                            onMouseLeave={(e) => e.target.style.backgroundColor = '#b15cd6'}
                        >
                            Export
                        </button>
                    </div>

                    {/* Search Bar - Always on top for mobile, on right for desktop */}
                    <div style={{
                        position: 'relative',
                        width: '100%',
                        maxWidth: window.innerWidth < 768 ? '200' : '250px',
                        minWidth: window.innerWidth < 480 ? '150px' : '200px',
                        margin: 0,
                        order: window.innerWidth < 768 ? 1 : 0, // Search comes first on mobile
                        zIndex: 1
                    }}>
                        <input
                            type="text"
                            placeholder="Search dishes or categories..."
                            value={searchQuery}
                            onChange={(e) => setSearchQuery(e.target.value)}
                            onKeyDown={(e) => {
                                if (e.key === 'Enter') handleSearch(searchQuery);
                            }}
                            onKeyUp={(e) => {
                                if (e.key !== 'Enter' && e.key !== 'Tab') {
                                    handleSearch(searchQuery);
                                }
                            }}
                            style={{
                                width: '100%',
                                padding: window.innerWidth < 480 ? '8px 40px 8px 12px' :
                                    window.innerWidth < 768 ? '10px 42px 10px 14px' : '10px 42px 10px 16px',
                                borderRadius: '20px',
                                border: '2px solid #b15cd6',
                                fontSize: window.innerWidth < 480 ? '0.875rem' :
                                    window.innerWidth < 768 ? '0.9rem' : '1rem',
                                outline: 'none',
                                transition: 'all 0.3s ease',
                                backgroundColor: '#fff',
                                height: window.innerWidth < 480 ? '36px' :
                                    window.innerWidth < 768 ? '38px' : '40px',
                                boxSizing: 'border-box',
                                fontFamily: 'inherit',
                            }}
                            onFocus={(e) => {
                                e.target.style.boxShadow = '0 0 0 2px rgba(177, 92, 214, 0.2)';
                            }}
                            onBlur={(e) => {
                                e.target.style.boxShadow = 'none';
                            }}
                        />
                        <button
                            onClick={() => handleSearch(searchQuery)}
                            style={{
                                position: 'absolute',
                                right: window.innerWidth < 480 ? '10px' :
                                    window.innerWidth < 768 ? '5px' : '10px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                background: 'transparent',
                                border: 'none',
                                cursor: 'pointer',
                                padding: '4px',
                                display: 'flex',
                                alignItems: 'center',
                                justifyContent: 'center',
                                zIndex: 2
                            }}
                            type="button"
                            aria-label="Search"
                        >
                            <svg
                                width={window.innerWidth < 480 ? "18" :
                                    window.innerWidth < 768 ? "20" : "22"}
                                height={window.innerWidth < 480 ? "18" :
                                    window.innerWidth < 768 ? "20" : "22"}
                                viewBox="0 0 24 24"
                                fill="none"
                                stroke="#b15cd6"
                                strokeWidth="2"
                            >
                                <circle cx="11" cy="11" r="8" />
                                <path d="m21 21-4.3-4.3" />
                            </svg>
                        </button>

                        {/* Clear button for search */}
                        {searchQuery && (
                            <button
                                onClick={() => {
                                    setSearchQuery("");
                                    handleSearch("");
                                }}
                                style={{
                                    position: 'absolute',
                                    right: window.innerWidth < 480 ? '35px' :
                                        window.innerWidth < 768 ? '40px' : '45px',
                                    top: '50%',
                                    transform: 'translateY(-50%)',
                                    background: 'transparent',
                                    border: 'none',
                                    cursor: 'pointer',
                                    padding: '2px',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center',
                                    color: '#888',
                                    fontSize: window.innerWidth < 480 ? '18px' : '20px',
                                    fontWeight: 'bold',
                                    zIndex: 2
                                }}
                                type="button"
                                aria-label="Clear search"
                            >
                                ×
                            </button>
                        )}
                    </div>
                </div>

                {/* Single Table Container with Fixed Header */}
                <div
                    ref={tableContainerRef}
                    style={{
                        height: window.innerHeight <= 500 ? "45vh" : window.innerHeight <= 600 ? "50vh" : "55vh",
                        border: '0px solid #ddd',
                        borderRadius: '0.375rem',
                        backgroundColor: '#fff',
                        width: '100%',
                        maxWidth: '100%',
                        boxSizing: 'border-box',
                        overflow: 'hidden',
                        display: 'flex',
                        flexDirection: 'column'
                    }}
                >
                    {loading ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '1.25rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                        }}>
                            <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                                Loading discount data...
                            </p>
                        </div>
                    ) : error ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '1.25rem',
                            color: 'red',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                        }}>
                            <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                                Error: {error.message}
                            </p>
                        </div>
                    ) : filteredData.length === 0 ? (
                        <div style={{
                            textAlign: 'center',
                            padding: '1.25rem',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            height: '100%'
                        }}>
                            <p style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                                No items with discounts found
                            </p>
                        </div>
                    ) : (
                        <div style={{
                            overflow: 'auto',
                            height: '100%',
                            scrollbarWidth: "thin",

                        }}>
                            <table style={{
                                width: '100%',
                                borderCollapse: 'collapse',
                                tableLayout: 'fixed',
                                // minWidth: getResponsiveValue('600px', '800px', '1000px'),
                                marginTop: "0px",
                            }}>
                                <thead>
                                    <tr>
                                        <th style={{ ...tableHeaderStyle, width: '7%' }}>
                                            <input
                                                type="checkbox"
                                                checked={Object.keys(selectedItems).length > 0 &&
                                                    Object.keys(selectedItems).length ===
                                                    data.reduce((total, category) =>
                                                        total + 1 + (category.subcategories?.length || 0), 0)}
                                                onChange={handleSelectAll}
                                                style={{ cursor: 'pointer' }}
                                            />
                                        </th>
                                        <th style={{ ...tableHeaderStyle, width: '10%' }}>SNo</th>
                                        <th style={{ ...tableHeaderStyle, width: '29%' }}>Category</th>
                                        <th style={{ ...tableHeaderStyle, width: '29%' }}>Discount(%)</th>
                                        <th style={{ ...tableHeaderStyle, width: '25%' }}>Actions</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {filteredData.map((item, index) => (
                                        <React.Fragment key={item.dishId}>
                                            {/* Parent Category Row */}
                                            {/* Parent Category Row */}
                                            <tr style={categoryRowStyle}>
                                                <td style={{ ...tableCellStyle, width: '5%' }}>
                                                    <input
                                                        type="checkbox"
                                                        ref={(el) => {
                                                            if (el) {
                                                                el.indeterminate = isParentIndeterminate(index);
                                                            }
                                                        }}
                                                        checked={!!selectedItems[item.dishId]}
                                                        onChange={() => handleParentCheckboxChange(index, item.dishId)}
                                                        style={{ cursor: 'pointer' }}
                                                    />
                                                </td>
                                                <td style={{ ...tableCellStyle, width: '8%' }}>{index + 1}</td>
                                                <td style={{ ...tableCellStyle, width: '35%' }}>
                                                    <strong style={{ fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem') }}>
                                                        {item.category}
                                                    </strong>
                                                </td>
                                                <td style={{ ...tableCellStyle, width: '30%' }}>
                                                    <span style={{
                                                        color: item.discount !== "-" ? '#e74c3c' : '#666',
                                                        fontWeight: item.discount !== "-" ? 'bold' : 'normal',
                                                        fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem')
                                                    }}>
                                                        -
                                                    </span>
                                                </td>
                                                <td style={{ ...tableCellStyle, width: '22%' }}>
                                                    <div style={{
                                                        display: 'flex',
                                                        justifyContent: 'center',
                                                        alignItems: 'center',
                                                        gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
                                                    }}>
                                                        {/* <button
                                                        style={editButtonStyle}
                                                        onClick={() => handleEditDiscount(item, false)}
                                                        title="Edit Discount"
                                                        aria-label="Edit Discount"
                                                    >
                                                        <FaEdit />
                                                    </button> */}
                                                        <button
                                                            style={{
                                                                ...importExportButton,
                                                                padding: '5px 10px',
                                                                fontSize: '12px',
                                                                height: 'auto',
                                                                marginTop: "0px",
                                                            }}
                                                            onClick={handleBulkEdit}
                                                            disabled={getSelectedCount() === 0}
                                                        >
                                                            Bulk Edit
                                                        </button>
                                                    </div>
                                                </td>
                                            </tr>

                                            {/* Subcategories */}
                                            {/* Subcategories */}
                                            {/* Subcategories */}
                                            {item.subcategories && item.subcategories.map((sub, subIndex) => {
                                                const subKey = `${index}-${sub.dishId}`;
                                                return (
                                                    <tr key={`sub-${sub.dishId}`} style={subcategoryRowStyle}>
                                                        <td style={{ ...tableCellStyle, width: '5%' }}>
                                                            <input
                                                                type="checkbox"
                                                                checked={!!selectedItems[subKey]}
                                                                onChange={() => handleCheckboxChange(sub.dishId, true, index)}
                                                                style={{ cursor: 'pointer' }}
                                                            />
                                                        </td>
                                                        <td style={{ ...tableCellStyle, width: '8%' }}>
                                                            {index + 1}.{subIndex + 1}
                                                        </td>
                                                        <td style={{ ...tableCellStyle, width: '35%' }}>
                                                            <span style={{
                                                                marginLeft: getResponsiveValue('1rem', '1.5rem', '2rem'),
                                                                display: 'block',
                                                                textAlign: 'left',
                                                                fontSize: getResponsiveValue('0.75rem', '0.875rem', '1rem')
                                                            }}>
                                                                ↳ {sub.subName}
                                                            </span>
                                                        </td>
                                                        <td style={{ ...tableCellStyle, width: '30%' }}>
                                                            <span style={{
                                                                color: sub.discount !== "-" ? '#292828ff' : '#666',
                                                                fontWeight: sub.discount !== "-" ? 'normal' : 'normal',
                                                                fontSize: getResponsiveValue('0.875rem', '1rem', '1.125rem')
                                                            }}>
                                                                {sub.discount}
                                                            </span>
                                                        </td>
                                                        <td style={{ ...tableCellStyle, width: '22%' }}>
                                                            <div style={{
                                                                display: 'flex',
                                                                justifyContent: 'center',
                                                                alignItems: 'center',
                                                                gap: getResponsiveValue('0.25rem', '0.5rem', '0.75rem')
                                                            }}>
                                                                <button
                                                                    style={editButtonStyle}
                                                                    onClick={() => handleEditDiscount(sub, true, index)}
                                                                    title="Edit Discount"
                                                                    aria-label="Edit Discount"
                                                                >
                                                                    <FaEdit />
                                                                </button>
                                                            </div>
                                                        </td>
                                                    </tr>
                                                );
                                            })}
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    )}
                </div>

                {/* Edit Discount Modal */}
                {showEditModal && editItem && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1000,
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            padding: '1.5rem',
                            borderRadius: '8px',
                            width: '280px',
                            maxWidth: '90%',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            position: 'relative',
                        }}>
                            <button
                                onClick={() => setShowEditModal(false)}
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '1.5rem',
                                    cursor: 'pointer',
                                    color: '#999',
                                }}
                            >
                                ×
                            </button>

                            <h3 style={{ marginBottom: '1rem', color: '#333', textAlign: 'center' }}>
                                Edit Discount
                            </h3>

                            {/* Offer Type Selection - Just for categorization */}
                            <div style={{ marginBottom: '1rem' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Offer Type:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    marginBottom: '10px'
                                }}>
                                    <button
                                        type="button"
                                        onClick={() => setEditItem({ ...editItem, newOfferType: "FESTIAVAL_OFFER" })}
                                        style={{
                                            flex: 1,
                                            padding: '0.5rem',
                                            border: `2px solid ${editItem.newOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#ddd'}`,
                                            borderRadius: '6px',
                                            backgroundColor: editItem.newOfferType === "FESTIAVAL_OFFER" ? '#f0e6f5' : 'white',
                                            cursor: 'pointer',
                                            fontWeight: editItem.newOfferType === "FESTIAVAL_OFFER" ? 'bold' : 'normal',
                                            color: editItem.newOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#333',
                                        }}
                                    >
                                        Festival Offer
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setEditItem({ ...editItem, newOfferType: "FLAT_OFFER" })}
                                        style={{
                                            flex: 1,
                                            padding: '0.5rem',
                                            border: `2px solid ${editItem.newOfferType === "FLAT_OFFER" ? '#b15cd6' : '#ddd'}`,
                                            borderRadius: '6px',
                                            backgroundColor: editItem.newOfferType === "FLAT_OFFER" ? '#f0e6f5' : 'white',
                                            cursor: 'pointer',
                                            fontWeight: editItem.newOfferType === "FLAT_OFFER" ? 'bold' : 'normal',
                                            color: editItem.newOfferType === "FLAT_OFFER" ? '#b15cd6' : '#333',
                                        }}
                                    >
                                        Flat Offer
                                    </button>
                                </div>
                            </div>

                            {/* Discount Value Input - Always Percentage */}
                            <div style={{ marginBottom: '1.5rem' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Discount Percentage:
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input
                                        type="number"
                                        value={editItem.newDiscountValue}
                                        onChange={(e) => setEditItem({ ...editItem, newDiscountValue: e.target.value })}
                                        style={{
                                            flex: 1,
                                            padding: '0.65rem',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '0.9rem',
                                        }}
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        placeholder="e.g. 10"
                                        autoFocus
                                    />
                                    <span style={{
                                        color: '#666',
                                        fontSize: '14px',
                                        fontWeight: 'bold',
                                        minWidth: '30px'
                                    }}>
                                        %
                                    </span>
                                </div>
                                <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                    Enter 0 to remove discount
                                </small>
                            </div>

                            {/* Save Button */}
                            <button
                                onClick={submitEditDiscount}
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    backgroundColor: '#b15cd6',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '1rem',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    marginTop: '5px'
                                }}
                            >
                                Save Discount
                            </button>

                        </div>
                    </div>
                )}
                {/* Bulk Edit Modal */}
                {showBulkEditModal && (
                    <div style={{
                        position: 'fixed',
                        top: 0,
                        left: 0,
                        right: 0,
                        bottom: 0,
                        backgroundColor: 'rgba(0,0,0,0.5)',
                        display: 'flex',
                        justifyContent: 'center',
                        alignItems: 'center',
                        zIndex: 1001,
                    }}>
                        <div style={{
                            backgroundColor: 'white',
                            padding: '1.5rem',
                            borderRadius: '8px',
                            width: '350px',
                            maxWidth: '90%',
                            boxShadow: '0 4px 12px rgba(0,0,0,0.15)',
                            position: 'relative',
                        }}>
                            <button
                                onClick={() => setShowBulkEditModal(false)}
                                style={{
                                    position: 'absolute',
                                    top: '10px',
                                    right: '10px',
                                    background: 'none',
                                    border: 'none',
                                    fontSize: '1.5rem',
                                    cursor: 'pointer',
                                    color: '#999',
                                }}
                            >
                                ×
                            </button>

                            <h3 style={{ marginBottom: '1rem', color: '#333', textAlign: 'center' }}>
                                Bulk Discount Update
                            </h3>

                            <p style={{
                                marginBottom: '1rem',
                                textAlign: 'center',
                                color: '#666',
                                fontSize: '14px'
                            }}>
                                Updating {getSelectedCount()} selected item(s)
                            </p>

                            {/* Offer Type Selection for Bulk Edit */}
                            <div style={{ marginBottom: '1rem' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Offer Type:
                                </label>
                                <div style={{
                                    display: 'flex',
                                    gap: '10px',
                                    marginBottom: '15px'
                                }}>
                                    <button
                                        type="button"
                                        onClick={() => setBulkOfferType("FESTIAVAL_OFFER")}
                                        style={{
                                            flex: 1,
                                            padding: '0.6rem',
                                            border: `2px solid ${bulkOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#ddd'}`,
                                            borderRadius: '6px',
                                            backgroundColor: bulkOfferType === "FESTIAVAL_OFFER" ? '#f0e6f5' : 'white',
                                            cursor: 'pointer',
                                            fontWeight: bulkOfferType === "FESTIAVAL_OFFER" ? 'bold' : 'normal',
                                            color: bulkOfferType === "FESTIAVAL_OFFER" ? '#b15cd6' : '#333',
                                            fontSize: '14px'
                                        }}
                                    >
                                        Festival Offer
                                    </button>
                                    <button
                                        type="button"
                                        onClick={() => setBulkOfferType("FLAT_OFFER")}
                                        style={{
                                            flex: 1,
                                            padding: '0.6rem',
                                            border: `2px solid ${bulkOfferType === "FLAT_OFFER" ? '#b15cd6' : '#ddd'}`,
                                            borderRadius: '6px',
                                            backgroundColor: bulkOfferType === "FLAT_OFFER" ? '#f0e6f5' : 'white',
                                            cursor: 'pointer',
                                            fontWeight: bulkOfferType === "FLAT_OFFER" ? 'bold' : 'normal',
                                            color: bulkOfferType === "FLAT_OFFER" ? '#b15cd6' : '#333',
                                            fontSize: '14px'
                                        }}
                                    >
                                        Flat Offer
                                    </button>
                                </div>
                            </div>

                            {/* Discount Percentage Input */}
                            <div style={{ marginBottom: '1.5rem' }}>
                                <label style={{
                                    display: 'block',
                                    marginBottom: '0.5rem',
                                    fontWeight: '500',
                                    color: '#333',
                                    fontSize: '14px'
                                }}>
                                    Discount Percentage:
                                </label>
                                <div style={{ display: 'flex', alignItems: 'center', gap: '8px' }}>
                                    <input
                                        type="number"
                                        value={bulkDiscountValue}
                                        onChange={(e) => setBulkDiscountValue(e.target.value)}
                                        style={{
                                            flex: 1,
                                            padding: '0.75rem',
                                            border: '1px solid #ddd',
                                            borderRadius: '6px',
                                            fontSize: '1rem',
                                        }}
                                        min="0"
                                        max="100"
                                        step="0.1"
                                        placeholder="Enter discount %"
                                        autoFocus
                                    />
                                    <span style={{
                                        color: '#666',
                                        fontSize: '16px',
                                        fontWeight: 'bold',
                                        minWidth: '30px'
                                    }}>
                                        %
                                    </span>
                                </div>
                                <small style={{ color: '#666', fontSize: '12px', marginTop: '5px', display: 'block' }}>
                                    Enter 0 to remove discount from all selected items
                                </small>
                            </div>

                            {/* Apply Button */}
                            <button
                                onClick={applyBulkDiscount}
                                style={{
                                    width: '100%',
                                    padding: '0.75rem',
                                    backgroundColor: '#b15cd6',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '6px',
                                    fontSize: '1rem',
                                    cursor: 'pointer',
                                    fontWeight: 'bold',
                                    marginTop: '5px'
                                }}
                            >
                                Apply to All Selected Items
                            </button>

                        </div>
                    </div>
                )}

                <style jsx>{`
                /* CSS for fixed header */
                .table-container {
                    position: relative;
                    height: ${containerHeight};
                    overflow: auto;
                }
                
                .table-container thead th {
                    position: sticky;
                    top: 0;
                    background-color: #b15cd6;
                    z-index: 10;
                }
                
                /* Hide scrollbar for Chrome, Safari and Opera */
                .table-container::-webkit-scrollbar {
                    width: 8px;
                    height: 8px;
                }
                
                .table-container::-webkit-scrollbar-track {
                    background: #f1f1f1;
                }
                
                .table-container::-webkit-scrollbar-thumb {
                    background: #888;
                    border-radius: 4px;
                }
                
                .table-container::-webkit-scrollbar-thumb:hover {
                    background: #555;
                }
            `}</style>
            </div>
          
        </>
    );
};

export default ItemDiscounts;